import React from 'react';
import styled from 'styled-components';

type TProps = {
    active: boolean;
};

const Switch = ({ active }: TProps): JSX.Element => {
    return <Toggle className={`switchToggle${active ? ' active' : ''}`} />;
};

const Toggle = styled.div`
    ${({ theme: { left } }): string => `margin-${left}: auto`};
    height: 20px;
    width: 36px;
    background-color: #d2d7e0;
    border-radius: 10px;
    position: relative;
    transition: opacity 0.2s ease-in-out;

    &:after {
        content: '';
        position: absolute;
        ${({ theme: { left } }): string => `${left}: 2px`};
        top: 2px;
        width: 16px;
        height: 16px;
        background-color: ${({ theme: { colors } }): string => colors.bgPrimary};
        border-radius: 100%;
        transition: ${({ theme: { left } }): string => `${left} ease-in-out 0.4s`};
    }

    &:hover {
        opacity: 0.7;
    }

    &.active {
        background-color: ${({ theme: { colors } }): string => colors.brandPrimary};

        &:after {
            ${({ theme: { left } }): string => `${left}: 18px`};
        }
    }
`;

export default Switch;
